import { useQuery } from '@tanstack/react-query';
import { getTimeTillEndOfDayMs } from '@toggle/helpers';
import {
  EconomicsResponseInput,
  economicsResponseInputSchema,
  financialEvents,
} from '@toggle/toggle';

import { wretchRequest } from '~/utils/api-fetch/apiFetch';

export const US_COUNTRY_CODE = 'US';

const QUERY_KEY_ECONOMICS_EVENTS = 'QUERY_KEY_ECONOMICS_EVENTS';
export interface UseEconomicsEventsProps {
  from: string;
  to: string;
  countries?: string[];
}

export const useEconomicsEvents = ({
  from,
  to,
  countries,
}: UseEconomicsEventsProps) =>
  useQuery({
    queryKey: [QUERY_KEY_ECONOMICS_EVENTS, to, from, countries],
    queryFn: ({ signal }) => {
      const { path, schema } = financialEvents.getEconomics;
      return wretchRequest<EconomicsResponseInput>(
        path({ from, to, countries }),
        {
          schema,
          signal,
        }
      );
    },
    select: data => {
      const parsedData = economicsResponseInputSchema.parse(data);
      return parsedData.economics.sort((a, b) => {
        return new Date(a.date).getTime() - new Date(b.date).getTime();
      });
    },
    staleTime: getTimeTillEndOfDayMs(),
  });
